/** @format */

import { useContext, ReactNode, useMemo } from "react";
import { Context } from "../../../../stores/Provider";
import styled from "styled-components";
import { Box } from "../../../layouts/Box";
import { FlexBox } from "../../../layouts/FlexBox";
import { MessageBox } from "../../../style/DashboardStyle";
import { BackButton } from "../../../ui-parts";
import { getSession } from "../../../../sessionStorage/sessionStorageMethod";
import useNavigateByAgent from "../../../../hooks/useNavigateByAgentHooks";

const Wrapper = styled.div`
  position: relative;
`;

const LinkText = styled.p`
  margin: 0;
`;

const DashboardMessageElement = ({ mainMessage = <></>, step = 1 }: { mainMessage: ReactNode; step: number }) => {
  const { state, dispatch } = useContext(Context);
  const { navigateByAgent } = useNavigateByAgent();
  const entryInfoData = getSession("entry");
  const entryInfosCount = getSession("entry_infos_count");
  const zAccount = useMemo(() => state.zAccount, [state.zAccount]);
  const returnToEntrySelect = () => {
    dispatch({
      type: "set-context-data",
      payload: {
        user_status: {
          status: "",
        },
      },
    });
    navigateByAgent("/entry_select");
  };

  return (
    <section>
      <Box contentsWidth>
        <Wrapper>
          <FlexBox sx={"alignItems: center"} spaceBetween>
            <div style={{ flex: 1, textAlign: "center" }}>
              <h1>Web申込システム</h1>
            </div>
            {((zAccount === "ocnk" &&
              Object.keys(entryInfoData).length === 1 &&
              entryInfoData["0"]["status"] !== "ENTRING") ||
              entryInfosCount >= 2) && (
              <div className="display-desktop" style={{ position: "absolute", right: 0 }}>
                <BackButton>
                  <LinkText onClick={() => returnToEntrySelect()}>お申し込み履歴画面に戻る</LinkText>
                </BackButton>
              </div>
            )}
          </FlexBox>
          {((zAccount === "ocnk" &&
            Object.keys(entryInfoData).length === 1 &&
            entryInfoData["0"]["status"] !== "ENTRING") ||
            entryInfosCount >= 2) && (
            <div className="display-mobile align_right" style={{ marginBottom: "16px" }}>
              <BackButton>
                <LinkText onClick={() => returnToEntrySelect()}>お申し込み履歴画面に戻る</LinkText>
              </BackButton>
            </div>
          )}
          <p className="align_center">下記の手順に沿って必要な情報を入力の上、お申し込みください。</p>
        </Wrapper>
      </Box>
      <Box mt_desktop={32} mt_mobile={16} contentsWidth>
        <MessageBox data-stepcount={step}>
          <div className="inner">{mainMessage}</div>
        </MessageBox>
      </Box>
    </section>
  );
};

export default DashboardMessageElement;
